import React, { useEffect, useState } from "react";
import { useAuth } from "../firebase/AuthContext";
import { useLocation } from "react-router-dom";

function RefreshToken({ className = "" }) {
    const { currentUser } = useAuth();
    const location = useLocation();
    const getLangFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get("lang") === "zh" ? "zh" : "en";
    };

    const [language, setLanguage] = useState(getLangFromUrl());

    useEffect(() => {
        setLanguage(getLangFromUrl());
        // eslint-disable-next-line
    }, [location.search]);

    const refreshToken = async () => {
        try {
            if (!currentUser) {
                console.warn(
                    "No authenticated user available to refresh token.",
                );
                alert("No authenticated user available to refresh token.");
                return;
            }

            const refreshedToken = await currentUser.getIdToken(true);
            console.log("Token refreshed successfully!", refreshedToken);

            // Reload the current page so the app picks up the new token
            window.location.reload();
        } catch (error) {
            console.error("Failed to refresh token:", error);
            alert(`Failed to refresh token: ${error.message}`);
        }
    };

    return (
        <div className={className}>
            <button
                onClick={refreshToken}
                className={`${
                    className ? "" : ""
                } inline-flex items-center gap-2 px-6 py-3 bg-slate-500 hover:bg-gray-600 backdrop-blur-sm border border-white/20 rounded-xl text-sm text-white font-medium transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl`}
                title="Refresh authentication token to get latest permissions"
            >
                <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                </svg>
                {language === "en" ? "Refresh Token" : "刷新令牌"}
            </button>{" "}
        </div>
    );
}

export default RefreshToken;
